import React, { useMemo } from "react";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { DonutChartDataItem } from "../highcharts";
import { LegendRow } from "./DonutChartRow";

const DonutChartLegendContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  width: "40%",
  flexShrink: 0,
  minWidth: "300px",

  [theme.breakpoints.down("md")]: {
    width: "50%",
  },

  [theme.breakpoints.down(950)]: {
    width: "100%",
  },
}));

const calculatePercent = (value: number, total: number) => {
  return Math.round((Math.abs(value) / Math.abs(total)) * 100);
};

type Props = {
  data: DonutChartDataItem[];
  displayLegend?: boolean;
  onLegendClick: (id: string) => void;
  activeLegend: string | null;
  overlayColors?: boolean;
};

export const DonutChartLegend = ({
  data,
  displayLegend,
  onLegendClick,
  activeLegend,
  overlayColors = false,
}: Props) => {
  const handleLegendClick = (item: DonutChartDataItem) => {
    onLegendClick(item.id);
  };

  const biggestValue = useMemo(
    () =>
      data.reduce(
        (acc, item) => {
          return Math.abs(item.value) > acc ? Math.abs(item.value) : acc;
        },
        Math.abs(data[0]?.value) || 0
      ),
    [data]
  );

  if (!displayLegend) return null;

  return (
    <DonutChartLegendContainer>
      {data.map((item) => {
        const percent = calculatePercent(item.value, biggestValue);
        const isOpen = activeLegend === item.id;

        return (
          <LegendRow
            key={item.id}
            item={item}
            percent={percent}
            isOpen={isOpen}
            handleLegendClick={handleLegendClick}
            overlayColors={overlayColors}
          />
        );
      })}
    </DonutChartLegendContainer>
  );
};
